import { formatSsn, Stack, Text, useText } from "@sveabank/cc-common";
import Image from "../../../../components/image";
import { usePageContext } from "../../../../hooks/context";
import { useClcCompanyApplication } from "../../hooks";
import { getCardholderPersonDetails } from "../../utils";

type Props = {
	cardHolderNationalId: string;
};

const ClcCardSummary = ({ cardHolderNationalId }: Props) => {
	const [t, texts] = useText();

	const {
		clcApplicationDetails: {
			companyRegistration: { value: companyRegistration },
			companyShares: { value: companyShares },
			representatives: { value: companyRepresentatives },
			beneficialOwners: { value: companyBeneficialOwnership },
		},
		cards: {
			debitCards: { availableCardHolders, cards },
		},
		selectedPackage,
	} = usePageContext(useClcCompanyApplication);

	const packageText = texts.newCompany.packages[selectedPackage.packageId];
	const isForetagarnaPackage = selectedPackage?.packageId === "FÖRETAGARNA-SVEA-STARTA-BOLAG";
	const card = cards.find((c) => c.nationalId === cardHolderNationalId && c.isConfigured);

	const shareholders = companyShares?.shareholders || [];
	const representatives = companyRepresentatives?.representatives || [];
	const beneficialOwners = companyBeneficialOwnership?.beneficialOwners || [];

	const cardHolders = getCardholderPersonDetails(
		availableCardHolders,
		shareholders,
		representatives,
		beneficialOwners,
	);

	const cardHolder = cardHolders.find((p) => p.nationalId === cardHolderNationalId);

	if (!companyRegistration || !card || !cardHolder) return null;

	return (
		<Stack gap={1} align="start">
			<Text bold>{`${cardHolder.firstName} ${cardHolder.lastName}`}</Text>
			<Text>{formatSsn(cardHolder.nationalId)}</Text>
			<Stack direction="row" gap={2}>
				<Image
					imageSrc={isForetagarnaPackage ? "FORETAGARNA_DEBIT" : "DEBITCARD"}
					className="h-12"
					altText={t(packageText.debitCard)}
				/>
				<Stack>
					<Text className="text-text-primary text-sm" bold>
						{card?.displayName || "Missing"}
					</Text>
					<Text className="text-sm">{companyRegistration.proposedCompanyNames[0] || ""}</Text>
				</Stack>
			</Stack>
		</Stack>
	);
};

export default ClcCardSummary;
